module.exports = __webpack_public_path__ + "img/waving-hand.00d2b15a.png";